import React, { useEffect } from "react"
// import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import { motion, useScroll, useTransform, useSpring } from "framer-motion"

import Layout from "../components/layout"
import { SEO } from "../components/seo"
import Places from "../components/places"
import StructuredDataWebpage from "../components/structured-data-webpage"

import videoPoster from "../images/061_0504_amalgam_naxos.webp"
import video from "../images/islands/naxos/iremia/iremia.mp4"

import "../css/home.css"

const Home = () => {
  const [showVideoModal, setShowVideoModal] = React.useState(false)
  const [hoverVideo, setHoverVideo] = React.useState(null)
  const { scrollYProgress } = useScroll()
  let yVideoResponsive = 0.5;
  let ySecondImageResponsive = "20vh";
  if (typeof window !== "undefined") {
    if (window.innerWidth < 992 && window.innerHeight > window.innerWidth) {
      yVideoResponsive = 0.75;
    }

    if (window.innerWidth < 492 && window.innerHeight < window.innerWidth) {
      ySecondImageResponsive = "50vh";
    }
  }
  const scaleVideo = useTransform(scrollYProgress, [0, 0.05], [yVideoResponsive, 1])
  const yVideo = useTransform(scrollYProgress, [0, 0.25], ["25vh", "0vh"])
  // Adjust this scale for the first image
  const scaleFirstImage = useTransform(scrollYProgress, [0, 1], [1, 0.8])
  
  const yFirstImage = useTransform(scrollYProgress, [0, 0.4], ["-50vh", "5vh"])
  
  // New scale transformation for the second image to move at a different "speed"
  const scaleSecondImage = useTransform(scrollYProgress, [0, 1], [1, 0.5])

  const ySecondImage = useTransform(scrollYProgress, [0, 0.4], [ySecondImageResponsive, "-50vh"])

  // Assuming scaleLarger and other parts of your code remain unchanged
  const transformText = useTransform(scrollYProgress, [0, 0.05], [1, 0.5])
  const larger = useSpring(transformText)

  useEffect(() => {
    larger.set(transformText)
  }, [transformText])


  useEffect(() => {
    if (hoverVideo !== null && typeof window !== 'undefined' && !showVideoModal && window.innerWidth > 992) {
      // set cursor position variables
      const cursor = document.querySelector('.cursor-circle');
      
      // replace cursor position variables with current cursor position

      const container = document.querySelector('.video-poster-container');
      const containerRect = container.getBoundingClientRect();
      
      container.addEventListener('mousemove', (e) => {
        cursor.style.left = `${e.clientX - containerRect.left}px`;
        cursor.style.top = `${e.clientY - containerRect.top}px`;
      })

      // don't show normal cursor
      document.body.style.cursor = 'none';

      container.addEventListener('mouseleave', () => {
        // hide cursor
        document.body.style.cursor = 'default';
      })
      
      
    }
  }, [hoverVideo])
  const heading_text = "Amalgam Homes".split("");
  const subheading_text = "The art of comfort".split("");
  return (
    <Layout
      backgroudColor="var(--color-primary)"
    >
      {/* Video Modal */}
      {/* <VideoModal 
        video={video}
        poster={videoPoster}
        show={showVideoModal}
        setShowVideoModal={setShowVideoModal}
      /> */}

      <div className="background-pattern">
        <div className="line"></div>
        <div className="line"></div>
        <div className="line"></div>
        <div className="line"></div>
      </div>
      <section id="video" className="home-video">
        
        <div className="video-container">
          <motion.div
            initial={{ scale: 1 }}
            style={{ scale: transformText }}
            transition={{ type: "spring", stiffness: 50 }}

            className="header-background-text-container-motion"
          >
            <div className="header-background-text-container">
              {heading_text.map((el, i) => (
                <motion.span
                  initial={{ opacity: 0.2, y: -25 }}
                  animate={{ opacity: 0.8, y: 0}}
                  transition={{
                    duration: 0.15,
                    delay: i / 25,
                  }}
                  key={i}
                  className="header-background-text"
                >
                  {el === " " ? "\u00A0" : el}{" "}
                </motion.span>))}
            </div>
            <div className="header-background-text-container">
              {subheading_text.map((el, i) => (
                <motion.span
                  initial={{ opacity: 0.1, y: -25 }}
                  animate={{ opacity: 1, y: 0}}
                  transition={{
                    duration: 0.15,
                    delay: (i / 25) + (heading_text.length / 25),
                  }}
                  key={i}
                  className="header-background-subheading"
                >
                  {el === " " ? "\u00A0" : el}{" "}
                </motion.span>))}
            </div>
          </motion.div>
          <motion.div
            initial={{ scale: 0.5, y: "25vh" }}
            style={{ scale: scaleVideo, y: yVideo }}
            transition={{ type: "spring", bounce: 0.25 }}
            className="video-poster-container"
            onMouseEnter={() => setHoverVideo(true)}
            onMouseLeave={() => setHoverVideo(null)}
            onClick={() => setShowVideoModal(true)}
          >
            {typeof window !== "undefined" && window.innerWidth > 992 && !showVideoModal && <span className={`cursor-circle ${hoverVideo ? "active" : ""}`}>

              Play <br /> Video
          </span>}
            {!showVideoModal && <StaticImage
              src="../images/061_0504_amalgam_naxos.webp"
              loading="eager"
              quality={70}
              objectFit="cover"
              alt="Amalgam Homes Villas for Rent in Paros and Naxos"
              formats={["auto", "webp"]}
              className="video-poster"
            />}
            {!showVideoModal && <div className="video-poster-overlay">
              {/* play button icon */}

              {typeof window !== "undefined" && window.innerWidth < 992 && <div className="play-button" onClick={() => setShowVideoModal(true)}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="50"
                  height="50"
                  viewBox="0 0 24 24"
                >
                  <path d="M8 5v14l11-7z" />
                </svg>
              </div> }
            </div>}
            
            {showVideoModal && <video controls poster={videoPoster}>
              <source src={video} type="video/mp4" />
              <p>Your browser {`doesn't`} support HTML5 video.</p>
            </video>}
          </motion.div>
        </div>
      </section>
      <section id="about" className="home-about">
        <h1>An ode to minimalism</h1>
        <p>
          Inspired by the blue of the Aegean, the slow paced Cycladic way of
          living and the unique light of Greece. Experience the ultimate summer
          dream: sea views, balmy bliss and a refreshing dip in your own private
          pool. We have created the perfect balance between absolute comfort and
          the natural beauty of the landscape. Soak up precious moments in
          paradise at our secluded oasis.
        </p>
      </section>
      <section className="header-motion-container">
        <motion.div
          initial={{y: "0vh"}}
          style={{ scale: scaleFirstImage, opacity: scaleFirstImage, y: yFirstImage }}
          className="home-header-image-motion"
        >
          <div className="home-header-image">
            <StaticImage
              src="../images/338_9436_eolos_amalgam.webp"
              loading="lazy"
              quality={80}
              objectFit="cover"
              alt="Amalgam Homes minimal home exterior design"
              formats={["auto", "webp"]}
            />
          </div>
        </motion.div>
        <motion.div
          initial={{y: "0vh"}}
          style={{ scale: scaleSecondImage, opacity: scaleSecondImage, y: ySecondImage }}
          className="home-header-image-2-motion"
        >
          <div className="home-header-image">
            <StaticImage
              src="../images/007_9967_amalgam_naxos.webp"
              loading="lazy"
              quality={70}
              objectFit="cover"
              alt="Amalgam Homes minimal home exterior design"
              formats={["auto", "webp"]}
            />
          </div>
        </motion.div>
      </section>
      <section id="places" className="home-places">
        <Places />
      </section>
      <div id="quote" className="amalgamation">
        <h3>We are the amalgamation of all things Aegean</h3>
      </div>
      <section id="absolute-comfort" className="home-absolute-comfort">
        <div className="absolute-comfort-container">
          <div className="absolute-comfort-image">
            <StaticImage
              src="../images/011_9921_amalgam_naxos.webp"
              loading="lazy"
              quality={70}
              objectFit="cover"
              alt="Amalgam Homes minimal interior design"
              formats={["auto", "webp"]}
            />
          </div>
          <div className="absolute-comfort-content">
            <div className="absolute-comfort-content-text-container">
              <h2>Absolute relaxation culminates with utmost comfort </h2>
              <hr />
              <p>
                We invite you to discover a world where absolute relaxation
                culminates with utmost comfort. Step away from your daily life
                and discover an unparalleled world where infinite views of blue
                waters and clear skies are the backdrop to the ultimate seaside
                escape. Unlock your senses and let the Greek light, inspire your
                path.
              </p>
            </div>
          </div>
        </div>
      </section>

    </Layout>
  )
}

/**
 * Head export to define metadata for the page
 *
 * See: https://www.gatsbyjs.com/docs/reference/built-in-components/gatsby-head/
 */
export default Home

export const Head = () => {
  return (
    <SEO title="Home">
      <StructuredDataWebpage
        path="/"
        name="Amalgam Homes"
        description="Luxury pool villas for rent in Paros, Mykonos, Tinos, and Naxos"
        breadcrumbItems={["Home"]}
      />
    </SEO>
  )
}